/**
 * Generated by orval v8.18.0 🍺
 * Do not edit manually.
 * LiftAI API
 * LiftAI elevator/lift asset-management REST API.
 * OpenAPI spec version: 1.0.0 (v1)
 */

/**
 * * `invoice` - Invoice
 * * `proposal` - Proposal
 * * `credit` - Credit
 */
export type InvoiceKindEnum = typeof InvoiceKindEnum[keyof typeof InvoiceKindEnum];


export const InvoiceKindEnum = {
  invoice: 'invoice',
  proposal: 'proposal',
  credit: 'credit',
} as const;
